(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-invoice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-invoice')) {
    const CART_INVOICE_ATTRIBUTES = ['fe-richiesta', 'fe-azienda', 'fe-piva'];

    class CartInvoice extends HTMLElement {
      constructor() {
        super();
        this.saveTimer = null;
        this.inFlight = null;
        this.dirty = false;
        this.saveFailed = false;
        this.bypassSubmit = false;
        this.invalidField = null;
        this.handleSubmit = this.handleSubmit.bind(this);
      }

      connectedCallback() {
        this.requestInput = this.querySelector('[data-invoice-request]');
        this.fieldsElement = this.querySelector('[data-invoice-fields]');
        this.fieldElements = Array.from(this.querySelectorAll('[data-invoice-field]'));
        this.summaryElement = this.querySelector('[data-invoice-summary]');
        this.saveErrorElement = this.querySelector('[data-invoice-save-error]');

        if (!this.requestInput || !this.fieldsElement) return;

        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('input', this.onInput.bind(this));

        // The checkout button lives in another section and submits the #cart form through
        // its form attribute, so the guard listens on document, in the capture phase.
        document.addEventListener('submit', this.handleSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('submit', this.handleSubmit, true);
        if (this.saveTimer) clearTimeout(this.saveTimer);
      }

      get requested() {
        return this.requestInput.checked;
      }

      onChange(event) {
        if (event.target === this.requestInput) {
          this.fieldsElement.hidden = !this.requested;
          if (!this.requested) this.clearErrors();
        }

        this.clearFieldError(event.target);
        this.scheduleSave();
      }

      onInput(event) {
        this.clearFieldError(event.target);
      }

      // The payload is always built from the DOM. An empty string tells Shopify to remove
      // the attribute, so unchecking the box clears the saved values.
      buildAttributes() {
        const attributes = {};
        CART_INVOICE_ATTRIBUTES.forEach((name) => {
          attributes[name] = '';
        });

        if (!this.requested) return attributes;

        attributes['fe-richiesta'] = 'on';
        this.fieldElements.forEach((field) => {
          attributes[field.dataset.invoiceField] = field.value.trim();
        });

        return attributes;
      }

      scheduleSave() {
        this.dirty = true;
        if (this.saveTimer) clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.save(), 300);
      }

      // Saves are chained instead of running in parallel: two concurrent POSTs can land out
      // of order, and the older one would win.
      save() {
        this.saveTimer = null;
        this.dirty = false;

        const body = JSON.stringify({ attributes: this.buildAttributes() });

        const chained = (this.inFlight || Promise.resolve())
          .then(() => fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }))
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            this.saveFailed = false;
            this.saveErrorElement.hidden = true;
          })
          .catch(() => {
            this.saveFailed = true;
            this.dirty = true;
            this.saveErrorElement.hidden = false;
          });

        this.inFlight = chained;
        chained.then(() => {
          if (this.inFlight === chained) this.inFlight = null;
        });

        return chained;
      }

      // `change` fires on blur, so a direct click on the checkout button can leave a save
      // pending while the browser navigates away.
      async flush() {
        if (this.saveTimer || this.dirty) {
          if (this.saveTimer) clearTimeout(this.saveTimer);
          await this.save();
          return;
        }
        if (this.inFlight) await this.inFlight;
      }

      handleSubmit(event) {
        if (this.bypassSubmit) return;

        const form = event.target;
        if (!(form instanceof HTMLFormElement) || form.id !== 'cart') return;

        const submitter = event.submitter;
        if (!submitter || submitter.name !== 'checkout') return;

        if (!this.validate()) {
          event.preventDefault();
          this.reveal();
          return;
        }

        if (!this.dirty && !this.inFlight && !this.saveTimer) return;

        event.preventDefault();
        this.flush().then(() => {
          // Going to checkout after a failed save would lose the invoice details exactly
          // when they are needed.
          if (this.saveFailed) {
            this.reveal();
            return;
          }
          this.bypassSubmit = true;
          form.requestSubmit(submitter);
          this.bypassSubmit = false;
        });
      }

      validate() {
        this.clearErrors();
        if (!this.requested) return true;

        this.fieldElements.forEach((field) => {
          if (field.value.trim()) return;
          this.showFieldError(field);
          if (!this.invalidField) this.invalidField = field;
        });

        if (!this.invalidField) return true;

        this.summaryElement.hidden = false;
        return false;
      }

      showFieldError(field) {
        field.setAttribute('aria-invalid', 'true');
        const error = document.getElementById(`${field.id}-error`);
        if (!error) return;
        error.hidden = false;
        field.setAttribute('aria-describedby', error.id);
      }

      clearFieldError(field) {
        if (!field || !field.dataset || field.dataset.invoiceField === undefined) return;

        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
        const error = document.getElementById(`${field.id}-error`);
        if (error) error.hidden = true;
        this.summaryElement.hidden = true;
      }

      clearErrors() {
        this.fieldElements.forEach((field) => this.clearFieldError(field));
        this.summaryElement.hidden = true;
        this.invalidField = null;
      }

      reveal() {
        const target = this.invalidField || this.requestInput;
        requestAnimationFrame(() => {
          target.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }
    }

    customElements.define('cart-invoice', CartInvoice);
  }
  } catch(e) { console.error(e); }
})();

})();
